export enum UserStatusEnum{
  pending = 'PENDING',
  active = 'ACTIVE',
  inactive = 'INACTIVE'
}
